"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itsTaskGroupSchema = void 0;
const yup = __importStar(require("yup"));
const its_task_schema_1 = require("../its-task/its-task.schema");
const utilities_1 = require("../../utilities");
const enums_1 = require("../../enums");
exports.itsTaskGroupSchema = yup.object().shape({
    id: yup.string().notRequired(),
    groupName: yup.string().required(),
    eventType: yup.string().required().oneOf((0, utilities_1.getEnumValues)(enums_1.CalendarEventTypes)).required(),
    aircrewTypeId: yup.string().required(),
    squadronId: yup.string().required(),
    groupType: yup.string().required(),
    tasks: yup.array().of(its_task_schema_1.itsTaskSchema).required(),
});
